import React from 'react';

export interface CastMemberInfo {
  name: string;
  role?: string;
  upload_asset_id?: string;
  bio?: string;
}

export interface CastFormProps {
  castList?: CastMemberInfo[];
  onChange?: (castList: CastMemberInfo[]) => void;
}

export default function CastForm({ castList = [{ name: '', role: '', upload_asset_id: '', bio: '' }], onChange }: CastFormProps) {
  const updateCast = (idx: number, field: keyof CastMemberInfo, val: string) => {
    const next = [...castList];
    next[idx] = { ...next[idx], [field]: val };
    onChange?.(next);
  };

  const addCast = () => {
    onChange?.([...castList, { name: '', role: '', upload_asset_id: '', bio: '' }]);
  };

  const removeCast = (idx: number) => {
    if (castList.length <= 1) return;
    onChange?.(castList.filter((_, i) => i !== idx));
  };

  return (
    <div className="space-y-5">
      <p className="text-sm text-foreground-600 mb-3">填写主要演员及角色信息，有助于平台精准分发与宣传推广。</p>
      {castList.map((member, idx) => (
        <div key={idx} className="p-5 rounded-xl border border-gray-200/80 bg-white shadow-2xs space-y-4">
          <div className="flex items-center justify-between pb-2 border-b border-gray-100">
            <span className="text-sm font-bold text-primary-700 bg-primary-50 border border-primary-100 px-3.5 py-1.5 rounded-full">演员 #{idx + 1}</span>
            {castList.length > 1 && (
              <button onClick={() => removeCast(idx)} className="text-xs md:text-sm text-foreground-400 hover:text-red-500 font-medium cursor-pointer transition-colors" type="button">
                <i className="ri-delete-bin-line mr-1"></i> 删除
              </button>
            )}
          </div>
          <div>
            <label className="block text-sm font-bold text-foreground-800 mb-2">演员姓名</label>
            <input
              type="text"
              value={member.name || ''}
              onChange={(e) => updateCast(idx, 'name', e.target.value)}
              placeholder="请输入演员姓名"
              className="w-full px-4 py-3 rounded-lg bg-white border border-gray-200/80 text-base text-foreground-950 placeholder-foreground-400 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-400/20 transition-all"
            />
          </div>
          <div>
            <label className="block text-sm font-bold text-foreground-800 mb-2">角色简介</label>
            <textarea
              value={member.bio || ''}
              onChange={(e) => updateCast(idx, 'bio', e.target.value)}
              placeholder="简述角色性格和故事线..."
              rows={2}
              className="w-full px-4 py-3 rounded-lg bg-white border border-gray-200/80 text-base text-foreground-950 placeholder-foreground-400 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-400/20 transition-all resize-none"
            />
          </div>
        </div>
      ))}
      <button onClick={addCast} className="w-full py-3.5 rounded-xl border-2 border-dashed border-gray-300 text-base font-semibold text-foreground-600 hover:border-primary-400 hover:text-primary-600 transition-all cursor-pointer flex items-center justify-center gap-2" type="button">
        <i className="ri-add-line text-lg"></i>添加演员
      </button>
    </div>
  );
}